// extracted by mini-css-extract-plugin
export default {"image":"LinkImageCard_image__7dcrI","link":"LinkImageCard_link__n4BAe"};